import { useEffect, useState } from 'react';
import { useCurrentModule } from '../components';
import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
import { useEclipsePlanRecommendation } from './useEclipsePlanRecommendation';
const ANALYZING_MIN_MS = 1500;
const ANALYZING_MAX_MS = 12000;
const DECIDING_MS = 1200;
export const useAiRevealController = () => {
  const module = useCurrentModule();
  const {
    isEnabled
  } = useAiRecommendationEnabled();
  const {
    isBulletsLoading
  } = useEclipsePlanRecommendation();
  const isDeciding = module.SDK.aiRecommendationStore.useIsDeciding();
  const isRevealed = module.SDK.aiRecommendationStore.useIsRevealed();
  const plansRendered = module.SDK.aiRecommendationStore.useArePlansRendered();
  const [floorReached, setFloorReached] = useState(false);
  useEffect(() => {
    if (!isEnabled || isDeciding || isRevealed || !plansRendered) {
      return undefined;
    }
    const floor = setTimeout(() => setFloorReached(true), ANALYZING_MIN_MS);
    const ceiling = setTimeout(() => module.SDK.aiRecommendationStore.decide(), ANALYZING_MAX_MS);
    return () => {
      clearTimeout(floor);
      clearTimeout(ceiling);
    };
  }, [isEnabled, isDeciding, isRevealed, plansRendered, module]);
  useEffect(() => {
    if (isEnabled && plansRendered && floorReached && !isBulletsLoading && !isDeciding && !isRevealed) {
      module.SDK.aiRecommendationStore.decide();
    }
  }, [isEnabled, plansRendered, floorReached, isBulletsLoading, isDeciding, isRevealed, module]);
  useEffect(() => {
    if (!isDeciding || isRevealed) {
      return undefined;
    }
    const timer = setTimeout(() => module.SDK.aiRecommendationStore.reveal(), DECIDING_MS);
    return () => clearTimeout(timer);
  }, [isDeciding, isRevealed, module]);
};
//# sourceMappingURL=useAiRevealController.js.map